import React, { useCallback } from "react";
import RegisterRiskModal from "./index";
import { useModal } from "@/hooks/modals/useModal";

// ==================== 主组件 ====================
/**
 * RegisterRiskModal 适配器组件
 * 用于将 Modal 系统的 props 转换为 RegisterRiskModal 组件所需的 props
 *
 * 根据是否有 taskId 来决定显示查看模式还是编辑模式：
 * - 有 taskId: 显示查看/审批模式（从工作台点击进入）
 * - 无 taskId: 显示新增/编辑模式（从列表页点击进入）
 */
const RegisterRiskModalAdapter: React.FC = () => {
  const { open, props, closeModal } = useModal("SUPPLIER_RISK_REGISTER");
  const {
    mode,
    viewStatus,
    recordId,
    taskId,
    onSuccess,
    flowStatus,
    isReadOnly,
    businessStatus,
  } = props || {};

  // 处理关闭
  const handleClose = useCallback(() => {
    closeModal();
    // 关闭后调用成功回调以刷新列表
    if (onSuccess) {
      onSuccess();
    }
  }, [closeModal, onSuccess]);

  // 处理提交
  const handleSubmit = useCallback(
    (data: any) => {
      // 提交成功后关闭 modal 并刷新列表
      handleClose();
    },
    [handleClose],
  );

  // 处理通知
  const handleNotify = useCallback(() => {
    // 通知成功后关闭 modal 并刷新列表
    handleClose();
  }, [handleClose]);

  // 判断是否为只读模式
  const isReadOnlyMode = viewStatus === true || isReadOnly;

  console.log("🔍 RegisterRiskModalAdapter - 参数:", {
    mode,
    taskId,
    recordId,
    viewStatus,
    flowStatus,
    businessStatus,
    isReadOnlyMode,
  });

  return (
    <RegisterRiskModal
      visible={open}
      editingId={recordId}
      onClose={handleClose}
      onSubmit={handleSubmit}
      onNotify={handleNotify}
      readOnly={isReadOnlyMode}
      isNotifyMode={false}
      businessStatus={businessStatus}
    />
  );
};

export default RegisterRiskModalAdapter;
